import React, { Component } from 'react';
import TagComponent from '../components/skill/tag.component';
class SkillContainer extends Component {    
    render() {        
        const data = this.props.data;
        const skills = data.map(item=>{
            return <TagComponent key={item.title} title={item.title} items={item.items} />
        })
        return (
            <section id="section-skills">
                <div className="container">
                    <div className="jumbotron">
                        <h1>Skills</h1>
                        <ul id="skills">
                            {skills}
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}

export default SkillContainer;



// WEBPACK FOOTER //
// ./src/containers/skill.container.jsx